import { nextFrame } from '@cycle-app/utilities/src/utils/async.util';

import { setCommandbar } from 'src/reactives/commandbar.reactive';

export const execCallbackAndHide = (callback: VoidFunction) => async () => {
  setCommandbar({ visible: false });
  await nextFrame();
  callback();
};
